"use strict";

exports.__esModule = true;
exports.default = void 0;

var _universalEnv = require("universal-env");

var _index = _interopRequireDefault(require("./web/index"));

var _index2 = _interopRequireDefault(require("./weex/index"));

var _index3 = _interopRequireDefault(require("./miniapp/ali/index"));

var _index4 = _interopRequireDefault(require("./miniapp/wechat/index"));

var _index5 = _interopRequireDefault(require("./miniapp/bytedance-microapp/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chooseImage = function () {
  return Promise.reject();
};

if (_universalEnv.isWeb) {
  chooseImage = _index.default;
} else if (_universalEnv.isWeex) {
  chooseImage = _index2.default;
} else if (_universalEnv.isMiniApp) {
  chooseImage = _index3.default;
} else if (_universalEnv.isByteDanceMicroApp) {
  chooseImage = _index5.default;
} else if (_universalEnv.isWeChatMiniProgram) {
  chooseImage = _index4.default;
}

var _default = chooseImage;
exports.default = _default;